import React, { useState } from 'react';
import { Send, Zap, Loader2 } from 'lucide-react';

const GameCard = ({ round, lang, onBet }) => {
  const [selectedNumber, setSelectedNumber] = useState('');
  const [betAmount, setBetAmount] = useState('');
  const [loading, setLoading] = useState(false);

  const isMegaRound = round === 10;

  const handleConfirm = async () => {
    // ১. ভ্যালিডেশন চেক
    if (!selectedNumber || !betAmount || betAmount <= 0) {
      alert(lang === 'bn' ? "সঠিক নম্বর এবং পয়েন্ট লিখুন!" : "Enter valid number and points!");
      return;
    }

    setLoading(true);

    const betData = {
      round: round,
      number: parseInt(selectedNumber),
      amount: parseInt(betAmount)
    };

    // ২. Dashboard থেকে আসা onBet ফাংশন কল করা
    const success = await onBet(betData);

    if (success) {
      alert(lang === 'bn' ? "বাজি সফলভাবে ধরা হয়েছে!" : "Bet Placed Successfully!");
      setSelectedNumber('');
      setBetAmount('');
    } else {
      alert(lang === 'bn' ? "ব্যালেন্স কম বা সার্ভার সমস্যা!" : "Low points or server error!");
    }
    
    setLoading(false);
  };

  return (
    <div className="group bg-white border-2 border-amazon-border rounded-2xl overflow-hidden hover:border-orange transition-all duration-300 shadow-sm hover:shadow-xl transform hover:-translate-y-1">
      {/* Header */}
      <div className={`p-3 text-center font-black flex justify-center items-center gap-2 ${isMegaRound ? 'bg-gradient-to-r from-orange to-amazon-yellow text-navy' : 'bg-navy text-white'}`}>
        {isMegaRound && <Zap size={18} className="animate-pulse" />}
        {lang === 'bn' ? `রাউন্ড ${round}` : `Round ${round}`}
        {isMegaRound && <span className="text-[10px] bg-navy text-white px-2 py-0.5 rounded-full ml-1">MEGA 90X</span>}
      </div>

      <div className="p-5 space-y-4">
        {/* Number Input */}
        <div className="flex flex-col">
          <label className="text-[10px] font-black text-gray-400 uppercase tracking-wider mb-1">
            {isMegaRound ? (lang === 'bn' ? "৩ সংখ্যার পাতি লিখুন" : "Enter 3-Digit Patti") : (lang === 'bn' ? "১টি সংখ্যা লিখুন" : "Enter Single Number")}
          </label>
          <input 
            type="number" 
            value={selectedNumber}
            onChange={(e) => setSelectedNumber(e.target.value)}
            placeholder={isMegaRound ? "e.g. 442" : "0-9"}
            className="bg-bg-gray border-2 border-transparent focus:border-orange p-3 rounded-xl font-bold text-navy outline-none transition-all"
            onInput={(e) => isMegaRound ? e.target.value = e.target.value.slice(0, 3) : e.target.value = e.target.value.slice(0, 1)}
          />
        </div>

        {/* Amount Input */}
        <div className="flex flex-col">
          <label className="text-[10px] font-black text-gray-500 uppercase tracking-wider mb-1">
            {lang === 'bn' ? "পয়েন্টের পরিমাণ" : "Bet Points"}
          </label>
          <div className="relative">
             <span className="absolute left-3 top-1/2 -translate-y-1/2 font-bold text-gray-400">🪙</span>
             <input 
               type="number" 
               value={betAmount}
               onChange={(e) => setBetAmount(e.target.value)}
               placeholder="10"
               className="w-full bg-bg-gray border-2 border-transparent focus:border-orange pl-8 pr-4 py-3 rounded-xl font-bold text-navy outline-none transition-all"
             />
          </div>
        </div>

        {/* Action Button */}
        <button 
          onClick={handleConfirm}
          disabled={loading}
          className={`w-full ${loading ? 'bg-gray-400' : 'bg-gradient-to-b from-amazon-yellow to-gold hover:from-orange hover:to-orange'} text-navy font-black py-3 rounded-xl shadow-md active:scale-95 transition-all flex items-center justify-center gap-2 group-hover:gap-4`}
        >
          {loading ? (
            <Loader2 className="animate-spin" size={20} />
          ) : (
            <>
              <span>{lang === 'bn' ? "কনফার্ম বাজি" : "PLACE BET"}</span>
              <Send size={18} />
            </>
          )}
        </button>
      </div>
    </div>
  );
};

export default GameCard;